@use '@design/design-tokens/typography/typography' as *;

.alertsIconRoot {
  position: relative;
  padding-top: 4px;
}

.unreadBadge {
  position: absolute;
  left: 16px;
  bottom: 19px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--surface-primary);
  color: var(--text-on-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  @include typography-v2-body-xs;
}
